/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserUsDto } from '../../models/user-us-dto';

export interface AddUser$Params {
  orid: number;
      body: UserUsDto
}

export function addUser(http: HttpClient, rootUrl: string, params: AddUser$Params, context?: HttpContext): Observable<StrictHttpResponse<UserUsDto>> {
  const rb = new RequestBuilder(rootUrl, addUser.PATH, 'post');
  if (params) {
    rb.path('orid', params.orid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserUsDto>;
    })
  );
}

addUser.PATH = '/adduser/{orid}';
